
export class PhotoType {
  id!: number;
  name!: string;
  status!: boolean;
  created_at: Date = new Date();
  updated_at: Date = new Date();
}
